import { JobOrder as ServerJobOrder } from 'server/models/JobOrder';

export { JobOrderData, JobOrderOptions } from 'server/models/JobOrder';

export class JobOrder extends ServerJobOrder {
    ApprovalOfCharges() {
        return this._approvalsOfCharges().length === 0 ? null : this._approvalsOfCharges()[0];
    }
}


// WEBPACK FOOTER //
// ./data/models/JobOrder.ts